module.exports = __webpack_public_path__ + "static/media/cogent.27cfa614.png";